import { faBell } from '@fortawesome/pro-light-svg-icons/faBell';
import { faBalloons } from '@fortawesome/pro-solid-svg-icons/faBalloons';
import { faBird } from '@fortawesome/pro-solid-svg-icons/faBird';
import { faCalendarDays } from '@fortawesome/pro-solid-svg-icons/faCalendarDays';
import { faCircleCheck } from '@fortawesome/pro-solid-svg-icons/faCircleCheck';
import { faCircleInfo } from '@fortawesome/pro-solid-svg-icons/faCircleInfo';
import { faCircleXmark } from '@fortawesome/pro-solid-svg-icons/faCircleXmark';
import { faCreditCard } from '@fortawesome/pro-solid-svg-icons/faCreditCard';
import { faCrown } from '@fortawesome/pro-solid-svg-icons/faCrown';
import { faFlowerTulip } from '@fortawesome/pro-solid-svg-icons/faFlowerTulip';
import { faTreeChristmas } from '@fortawesome/pro-solid-svg-icons/faTreeChristmas';
import { faTriangleExclamation } from '@fortawesome/pro-solid-svg-icons/faTriangleExclamation';
import { faTruck } from '@fortawesome/pro-solid-svg-icons/faTruck';
import { faUmbrellaBeach } from '@fortawesome/pro-solid-svg-icons/faUmbrellaBeach';
import { faVirus } from '@fortawesome/pro-solid-svg-icons/faVirus';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ClientEventTypes, ServiceEventType, useClientLimitedEvents } from '@ukpostbox/client-data';
import {
	Badge,
	Button,
	ButtonSize,
	Colour,
	ContentBlock,
	Directions,
	Drawer,
	FlexAlign,
	FlexGap,
	GenericLoader,
	MainMenuEntry,
	Placement,
	StackHorizontal,
	StackVertical,
	Tooltip,
	ToolTipPlacement,
	useLayout,
	useNotifications,
	useTranslation,
} from '@ukpostbox/frontend-framework';
import React, { useEffect, useState } from 'react';
import { faBorderNone } from '@fortawesome/pro-solid-svg-icons/faBorderNone';
import { MainMenuEntryWrapper } from '@ukpostbox/frontend-framework/lib/Components/Navigation/MainNavigation/MainMenuEntry';
import { useLayoutStore } from '@ukpostbox/frontend-framework/lib/Providers/Stores/LayoutStore';
import { IconDefinition } from '@fortawesome/pro-solid-svg-icons';
import { useSite } from '../Providers/SiteInterfaceProvider';
import { useAuthorisedUser } from '../../_Auth/Providers/AuthProvider';

const AlertIconMap: Record<string, IconDefinition> = {
	bell: faBell,
	'circle-info': faCircleInfo,
	'triangle-exclamation': faTriangleExclamation,
	'circle-check': faCircleCheck,
	'circle-xmark': faCircleXmark,
	'credit-card': faCreditCard,
	'calendar-days': faCalendarDays,
	truck: faTruck,
	'tree-christmas': faTreeChristmas,
	virus: faVirus,
	bird: faBird,
	'flower-tulip': faFlowerTulip,
	'umbrella-beach': faUmbrellaBeach,
	crown: faCrown,
	balloons: faBalloons,
};

type MapBannerEventsType = {};

function MapEventToasts() {
	const { t } = useTranslation();

	const sidebarOpen = useLayoutStore((state) => state.sidebarOpen);

	const { AddNotification } = useNotifications();
	const { isUltraWide } = useLayout();
	const { setServiceManager, AddViewedAlertId, LOCAL_STORAGE_KEYS } = useSite();
	const { data, status } = useClientLimitedEvents();

	const [eventsShown, setEventsShown] = useState<boolean>(false);
	const [alertCount, setAlertCount] = useState<number>(0);

	const HandleAlertDismissed = (id: number) => {
		AddViewedAlertId(id);
		setAlertCount((oldCount) => oldCount - 1);
	};

	const LoopEvents = (alertData: ServiceEventType[]) => {
		const filteredData: any = alertData.filter((item: any) => item.eventTypeId === ClientEventTypes.Service);
		const viewedIds = JSON.parse(
			LOCAL_STORAGE_KEYS && LOCAL_STORAGE_KEYS.EVENTS
				? (localStorage.getItem(LOCAL_STORAGE_KEYS.EVENTS) as string)
				: '[]',
		);

		setEventsShown(true);
		setAlertCount(filteredData.length);

		if (filteredData) {
			for (const item of filteredData) {
				if (!viewedIds.includes(item.id)) {
					AddNotification({
						title: item.metadata.Header,
						description: item.metadata.Body,
						icon: faCreditCard,
						manualClose: true,
						colour: item.metadata.StatusColour as Colour,
						removeCallback: () => HandleAlertDismissed(item.id),
						actionCallback: item.metadata.Link
							? () => window.open(item.metadata.Link, '_blank')
							: undefined,
						actionLabel: item.metadata.Link ? item.metadata.LinkText || 'Learn More' : undefined,
					});
				} else {
					setAlertCount((oldCount) => oldCount - 1);
				}
			}
		}
	};

	useEffect(() => {
		if (status === 'success' && data && !eventsShown) {
			console.log(status);
			// LoopEvents(data);
		}
	}, [status, data, eventsShown]);

	return (
		<Tooltip
			content={t('notifications.title')}
			position={ToolTipPlacement.Right}
			disabled={sidebarOpen || isUltraWide}
		>
			{status === 'pending' ? (
				// TODO: convert to main menu loader component
				<MainMenuEntryWrapper title={t('notifications.title')} icon={faBorderNone}>
					<GenericLoader />
				</MainMenuEntryWrapper>
			) : status === 'error' ? (
				<MainMenuEntry
					title={t('notifications.componentError')}
					customCallBack={() => setServiceManager(true)}
					icon={faBorderNone}
				/>
			) : (
				<MainMenuEntry
					title={t('notifications.title')}
					customCallBack={() => setServiceManager(true)}
					icon={faBell}
					addon={
						alertCount > 0 ? (
							<Badge value={alertCount} colour={Colour.Alert} placement={Placement.TopRight} />
						) : undefined
					}
				/>
			)}
		</Tooltip>
	);
}

function MapBannerEvents(props: MapBannerEventsType) {
	const { error, data, status } = useClientLimitedEvents();

	return (
		<StackVertical gap={FlexGap.Medium}>
			{status === 'pending' ? (
				<div className='side-navigation-entry'>
					<GenericLoader size='2x' />
				</div>
			) : status === 'error' ? (
				<ContentBlock error title={error.name} content={error.message} />
			) : (
				data &&
				data.map((item) => (
					<StackHorizontal key={`serviceEvent-${item.id}`}>
						<div
							className={`pl-xs pr-xs mr-xs ${item.metadata.StatusColour as Colour}`}
							style={{
								display: 'flex',
								alignItems: 'center',
								justifyContent: 'center',
								fontSize: '1.3em',
							}}
						>
							<FontAwesomeIcon icon={AlertIconMap[item.metadata.Icon]} />
						</div>
						<StackVertical align={FlexAlign.Start} gap={FlexGap.ExtraSmall}>
							<div>
								<strong style={{ fontWeight: 800 }}>{item.metadata.Header as string}</strong>
								<div>{item.metadata.Body}</div>
							</div>

							{item.metadata.Link && (
								<Button
									title={item.metadata.LinkText ?? 'Learn More'}
									onClick={() => window.open(item.metadata.Link, '_blank')}
									size={ButtonSize.Small}
								/>
							)}
						</StackVertical>
					</StackHorizontal>
				))
			)}
		</StackVertical>
	);
}

function ServiceAlertManager() {
	const { token } = useAuthorisedUser();
	const { setServiceManager, serviceManagerOpen } = useSite();

	return (
		<Drawer
			title='Notifications'
			isOpen={serviceManagerOpen}
			direction={Directions.End}
			closeCallback={() => setServiceManager(false)}
		>
			{token && <MapBannerEvents />}
		</Drawer>
	);
}

export { MapEventToasts, MapBannerEvents, ServiceAlertManager };
